<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h5 class="vue-title">
          <strong>{{ $t("PROFILE") }}</strong>
        </h5>
      </div>
      <br />
    </div>
    <b-form class="formTextSize" @submit.prevent="submitForm">
      <b-row>
        <b-col sm="4">
          <br />
          <h5 class="vue-title">
            <strong> {{ $t("ID") }} : {{ this.profileForm.userid }}</strong>
          </h5>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="4">
          <b-form-group id="addressField" label-for="input-1">
            <span>
              {{ $t("SURNAME") }}
              <span class="mandotry-color">*</span>
            </span>
            <b-form-input
              v-model.trim="$v.profileForm.last_name.$model"
              class="inputField"
              type="text"
              autocomplete="name"
            ></b-form-input>
            <show-errors
              :control="$v.profileForm.last_name"
              :field="$t('MANDATORY')"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group id="addressField" label-for="input-1">
            <span>
              {{ $t("NAME") }}
              <span class="mandotry-color">*</span>
            </span>
            <b-form-input
              v-model.trim="$v.profileForm.first_name.$model"
              class="inputField"
              type="text"
              autocomplete="name"
            ></b-form-input>
            <show-errors
              :control="$v.profileForm.first_name"
              :field="$t('MANDATORY')"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4">
          <b-form-group id="addressField" label-for="input-1">
            <span>
              {{ $t("EMAIL") }}
              <span class="mandotry-color">*</span>
            </span>
            <b-form-input
              v-model.trim="$v.profileForm.email.$model"
              class="inputField"
              type="text"
              autocomplete="name"
              @keypress="preventSpecialChar($event)"
            ></b-form-input>
            <show-errors
              :control="$v.profileForm.email"
              :field="$t('MANDATORY')"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group id="addressField" label-for="input-1">
            <span>
              {{ $t("PHONENUMBER") }}
              <span class="mandotry-color">*</span>
            </span>
            <b-form-input
              v-model.trim="$v.profileForm.contact_no.$model"
              class="inputField"
              type="text"
              autocomplete="name"
               @keypress="isNumberValidatorphone($event)"
               :maxlength="CONSTANTS.MaxPhone"
            ></b-form-input>
            <show-errors
              :control="$v.profileForm.contact_no"
              :field="$t('MANDATORY')"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <b-form-group id="addressField" label-for="input-1">
            <span>
              {{ $t("AUTHORITY") }}
              <span class="mandotry-color">*</span>
            </span>
            <b-form-input
              id="authority"
              v-model.trim="$v.profileForm.role_id.$model"
              value-field="id"
              text-field="name"
              disabled
            ></b-form-input>
            <show-errors
              :control="$v.profileForm.role_id"
              :field="$t('MANDATORY')"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="8" class="text-center">
          <b-button
            class="btn btn-secondary formTextSizeBlack mr-2"
            @click="gotoPreviousPage"
            >{{ $t("CANCEL") }}</b-button
          >
          <button class="btn btn-primary formTextSizeBlack" type="submit">
            {{ $t("ADDTO") }}
          </button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>
<script>
import ShowErrors from "@/components/ShowErrors";
import { CONSTANTS } from "@/shared/utils";
import { isNumberValidator, preventSpecialChar, isNumberValidatorphone,phoneDigitValidation } from "@/shared/utils.js";
import {
  required,
  minLength,
  email
} from "vuelidate/lib/validators";
import { UPDATE_PROFILE, GET_PROFILE } from "@/store/actions.type";
export default {
  name: "profile",
  components: {
    ShowErrors
  },
  data: function() {
    return {
      isNumberValidator: isNumberValidator,
      preventSpecialChar: preventSpecialChar,
       isNumberValidatorphone:isNumberValidatorphone,
      CONSTANTS: CONSTANTS,

      profileForm: {
        last_name: "",
        first_name: "",
        email: "",
        contact_no: "",
        role_id: null,
        userid: ""
      }
    };
  },
  /*validation for the Each fields in From */
  validations: {
    profileForm: {
      last_name: { required },
      first_name: { required },
      email: { required, email },
       contact_no: { required, phoneNumber: minLength(10) },
      role_id: { required },
    }
  },
  created() {
    this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
    this.$store.dispatch(GET_PROFILE).then(data => {
      this.isLoading.hide();
      if (_.get(data, "status", 0)) {
        let user = _.get(data, "user");
        let userDetails = _.get(data, "user.details");
        let role = _.get(data, "user.role");

        this.profileForm = {
          last_name: _.get(userDetails, "last_name", ""),
          first_name: _.get(userDetails, "first_name", ""),
          email: _.get(userDetails, "email", ""),
          contact_no: _.get(userDetails, "contact_no", ""),
          role_id: _.get(role, "name", ""),
          userid: _.get(user, "userid", ""),
        
        };
      }
    });
  },
  methods: {
    /*Submiting the Filled Form */
    submitForm(evt) {
      
    this.$v.$touch();
      if (!this.$v.profileForm.$invalid) {
         if(phoneDigitValidation(this.profileForm.contact_no) === true){
       this.$toast.error({
         message: this.$t("INVALIDPHONENO")
          });
          return;
      }
      
        this.isLoading = this.$loading.show({
          loader: "dots",
          color: "#007bff"
        });
        let payload = {
          last_name: this.profileForm.last_name,
          first_name: this.profileForm.first_name,
          email: this.profileForm.email,
          contact_no: this.profileForm.contact_no,
        };
        this.$store.dispatch(UPDATE_PROFILE, payload).then(data => {
          this.isLoading.hide();
          if (data.status == true) {
            this.$toast.success({
              message: data.message
            });
               this.$router.go(-1)
          
          } else {
            this.$toast.error({
              message: data.message
            });
          }
        });
      }
      },
    gotoPreviousPage(){
      this.$router.go(-1)
    }
  }
};
</script>
